import React from 'react'
import { observer } from 'mobx-react'
import { ResourceSelector as BaseResourceSelector } from '@morningtrain/react-fields'
import withTranslations from 'support/hoc/withTranslations'
import Select from './Select'
import * as Filters from 'support/filters'

function ResourceSelector (props) {
  return (
    <BaseResourceSelector {...props} selectComponent={Select}>
      <Filters.StaticFilter name='$per_page' value={9999999} />
      {props.children}
    </BaseResourceSelector>
  )
}

export default observer(withTranslations(ResourceSelector))
